import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy">
      <section className="hero-privacy">
        <div className="container">
          <div className="hero-privacy-content">
            <div className="hero-privacy-text bounce-in-left delay-1">
              <h1>Privacy Policy</h1>
              <p className="hero-privacy-subtitle bounce-in-up delay-2">
                How we collect, use, and protect your information
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-text bounce-in-up delay-1">
            
            <h3>About Us</h3>
            <p>
              Reach Language and Learning LLC operates reachlanguageandlearning.com. This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site. We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.
            </p>
            
            <h3>Information Collection & Use</h3>
            <p>
              While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name.
            </p>
            
            <h3>COPPA Compliance</h3>
            <p>
              Our website is not intended for children under 13. We do not knowingly collect personal information from children. If we become aware that we have inadvertently received personal data from a child under 13, we will delete it.
            </p>
            
            <h3>Accessibility Statement</h3>
            <p>
              Reach Language and Learning LLC is committed to making its website accessible to individuals with disabilities. If you experience difficulty accessing any part of this site, please contact us so we can assist you.
            </p>
            
            <h3>Governing Law</h3>
            <p>
              These Terms shall be governed in accordance with the laws of the State of Maryland, without regard to its conflict of law provisions.
            </p>
            
            <h3>Log Data</h3>
            <p>
              Like many site operators, we collect information that your browser sends whenever you visit our Site. This Log Data may include information such as your computer's Internet Protocol address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics. In addition, we may use third party services such as Google Analytics that collect, monitor and analyze this data.
            </p>
            
            <h3>Communications</h3>
            <p>
              We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that we feel is relevant to your interests.
            </p>
            
            <h3>Security</h3>
            <p>
              The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
            </p>
            
            <h3>Changes to this Privacy Policy</h3>
            <p>
              This Privacy Policy is effective as of July 1, 2025 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.
            </p>
            <p>
              We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy. If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.
            </p>
            
            <h3>Contact Us</h3>
            <p>
              If you have any questions about this Privacy Policy, please contact us.
            </p>
            <p>
              <strong>Gaby McLish M.S CCC-SLP</strong><br/>
              Speech Language Pathologist<br/>
              Reach Language and Learning LLC<br/>
              (202) 725-5233<br/>
              reachlanguageandlearning.com
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy; 